import { Component, Input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-artuntergrp-list-view',
  imports: [],
  templateUrl: './artuntergrp.list-view.html',
  styleUrls: ['./artuntergrp.list-view.css'],
})
export class ArtuntergrpListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
